import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getScopedKey } from '../utils/userScopedStorage';

const STORAGE_KEY = 'ats_recent_pages';
const MAX_RECENT = 6;

function readRecent() {
  try {
    return JSON.parse(localStorage.getItem(getScopedKey(STORAGE_KEY)) || '[]');
  } catch {
    return [];
  }
}

// RC18.2 Phase 3 — tracks the last few pages visited (by pathname), for the Command
// Palette's "Recent" section when opened with an empty query.
export function useTrackRecentPage(labelResolver) {
  const location = useLocation();

  useEffect(() => {
    const label = labelResolver(location.pathname);
    if (!label) return;
    const recent = readRecent().filter((r) => r.path !== location.pathname);
    recent.unshift({ path: location.pathname, label });
    localStorage.setItem(getScopedKey(STORAGE_KEY), JSON.stringify(recent.slice(0, MAX_RECENT)));
  }, [location.pathname, labelResolver]);
}

export function getRecentPages() {
  return readRecent();
}

export default getRecentPages;
